// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J4ki","colMin":"styles_colMin__2wFxF"};